import React from "react";
import { StandadCard } from "../../../../../../components/Cards";
import { AccountCircle, DirectionsCarFilled, StickyNote2 } from "@mui/icons-material";
import { TabPanel } from "../../../../../../components/Tabs/TabPanel";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { PageLoader } from "../../../../../../components/PageLoader/PageLoader";
import { LoadState, MODULE_IDS } from "../../../../../../constants/enums";
import { useDispatchWrapper } from "../../../../../../hooks";
import { clearCustomerPolicyDetailsState } from "../../../../../../redux/customerPolicyDetails/customerPolicyDetailsActions";
import { LifeInsuranceCustomerInfo } from "./CustomerInfo/CustomerInfo";
import { TabsList } from "../../../../../../components/Tabs/TabsList";
import { useParams } from "react-router-dom";

import { LifeInsurancePolicyAdminManager } from "./PolicyAdminManager/PolicyAdminManager";
import { LifeInsuranceRidersSection } from "./Riders/Riders";
import { usePremissions } from "../../../../../../security/PremissionsProvider/PremissionsProvider";
import { TabsUncontrolledProvider } from "../../../../../../contexts/TabsContextProvider/TabsContextUncontrolledProvider";

export const LifeInsuranceBasicDetails = () => {
  const { customerId, customerPolicyId } = useParams() as {
    customerId?: number;
    customerPolicyId?: number;
  };

  const [tab, setTab] = React.useState(0);
  // The merged customer-policy-details fetch is dispatched by the CustomerInfo
  // child via useCustomerPolicyDetails. This parent only observes the shared
  // slice for loading and the saved id used to gate the dependent tabs.
  const { details: customerInfo, customerPolicyId: mergedCustomerPolicyId } =
    useSelector((storeState: IStoreState) => storeState.customerPolicyDetails);
  const dispatch = useDispatchWrapper();

  // New-policy screen (no URL customerPolicyId): reset the shared merged slice
  // on mount so a previously-opened policy's id/details don't leak in.
  React.useEffect(() => {
    if (!customerPolicyId) {
      dispatch(clearCustomerPolicyDetailsState());
    }
     
  }, [customerPolicyId]);

  const savedCustomerPolicyId = customerPolicyId ?? mergedCustomerPolicyId;
  const { premissionsList } = usePremissions();
  const showAdminManager = premissionsList.find((x) => {
    if (
      x.module_key === MODULE_IDS.LIFE_AND_FINCANCIAL_POLICY_ADMIN_MANAGER &&
      x.show_module
    ) {
      return true;
    }
    return false;
  });

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  const changeStep = (newStep: number) => {
    setTab(newStep);
  };

  if (!customerId) {
    return null;
  }

  return (
    <PageLoader
      loading={customerInfo.loading === LoadState.InProgress}
      //  error={customerNotFoundError ? { message: customerNotFoundError } : null}
    >
      <TabsUncontrolledProvider step={tab} changeStep={changeStep}>
      <StandadCard>
        <TabsList
          sx={{ mb: 1 }}
          varaint="fullWidth"
          selectedTab={tab}
          tabs={[
            { label: "Customer Info", icon: <AccountCircle /> },

            // {
            //   label: "Policy Admin",
            //   icon: <StickyNote2 />,
            //   disabled: !savedCustomerPolicyId,
            // },
            {
              label: "Policy Admin Manager",
              icon: <StickyNote2 />,
              disabled: !savedCustomerPolicyId,
              // hidden: !showAdminManager,
            },
            {
              label: "Riders",
              icon: <DirectionsCarFilled />,
              disabled: !savedCustomerPolicyId,
            },
            // {
            //   label: "Premium",
            //   icon: <Receipt />,
            //   disabled: !savedCustomerPolicyId,
            // },
          ]}
          onChange={handleChange}
        />
        <TabPanel value={tab} index={0}>
          <LifeInsuranceCustomerInfo customerId={customerId} customerPolicyId={customerPolicyId} />
        </TabPanel>
        {savedCustomerPolicyId && (
          <>
           
            <TabPanel value={tab} index={1}>
              <LifeInsurancePolicyAdminManager
                customerpolicyId={savedCustomerPolicyId}
              />
            </TabPanel>
            <TabPanel value={tab} index={2}>
              <LifeInsuranceRidersSection
                customerpolicyId={savedCustomerPolicyId}
              />
            </TabPanel>
            {/* <TabPanel value={tab} index={3}>
              <LifeInsurancePremium customerpolicyId={savedCustomerPolicyId} />
            </TabPanel> */}
          </>
        )}
      </StandadCard>
      </TabsUncontrolledProvider>
    </PageLoader>
  );
};
